import { FC, ReactNode } from "react";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./Dividends.module.scss";

/**
 * The (i) beside a card, box or grid title: what the figures are and how to read them, on hover
 * or tap. Used on every Dividends view and on the stock Dividend tab's boxes.
 */
const HelpTip: FC<{ text: ReactNode; title: string }> = ({ text, title }) => (
    <Tooltip title={<div className={styles.helpText}>{text}</div>} arrow enterTouchDelay={0} leaveTouchDelay={6000}>
        <button type="button" className={styles.helpTip} aria-label={`About ${title}`} onClick={(e) => e.stopPropagation()}>
            <InfoOutlinedIcon fontSize="inherit" />
        </button>
    </Tooltip>
);

export default HelpTip;
